<template>
  <FullScreenLoading/>
</template>

<script>
import FullScreenLoading from './Self-Improvee/Generic/FullScreenLoading'

export default {
  components: {
    FullScreenLoading
  },
  mounted () {
    console.log('anon created.. ')
    this.$store.dispatch('auth/loginAnonymous', { notify: this.$vs.notify }).then(() => {
      this.$store.dispatch('ADD_INITIAL_LESSONS_DELAYED')
      this.$store.dispatch('ADD_INITIAL_NOTIFICATIONS_DELAYED')
    })
  }
}

</script>

<style lang="scss">
@import "../assets/css/loader.css";
</style>
